import RingShapeComponent from "./ring-shape-component";
import RingShapeConfig from "./ring-shape-config";
import RingShapeAdvancedConfig from "./ring-shape-advanced-config";

export default {
  RingShapeComponent,
  RingShapeConfig,
  RingShapeAdvancedConfig
};
